module.exports = __webpack_public_path__ + "static/media/about-contact.30be8aa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-contact.jpg
// module id = 365
// module chunks = 33